import { Zone } from '.';
import { jQuery } from '../../vendor/jquery';
import { getDisplays, getZoneById } from '../Display';
import { GlobalZone } from '../DO_NOT_TOUCH/GlobalScope/Api/Interface/Signage';
import { objectHasOwnProperty } from '../Utility';

type ZoneAction = keyof GlobalZone;

/**
 * Creates new zone collection to allow cross-talk
 */
class ZoneCollection {
    m_Zones: Zone[];
    /**
     * Addition to Zone Collection with mapping to events
     */
    EventNameMap: Record<string, string> = { 'Loop Complete': 'onLoopComplete' };

    constructor(zones: Zone[]) {
        this.m_Zones = zones;
    }

    /**
     * @deprecated
     */
    WaitFor(eventName: string): EventSyncObject {
        if (typeof this.EventNameMap[eventName] !== 'undefined') {
            eventName = this.EventNameMap[eventName];
        }

        return new EventSyncObject(this.m_Zones, eventName);
    }

    /**
     * @deprecated
     */
    Do(actionOrActions: ZoneAction | ZoneAction[]): void {
        if (!Array.isArray(actionOrActions)) {
            actionOrActions = [actionOrActions];
        }

        actionOrActions.forEach((action) => {
            this.m_Zones.forEach((zone) => {
                if (objectHasOwnProperty(zone, action)) {
                    if (typeof zone[action] === 'function') {
                        const fnAction: () => void = zone[action] as () => void;
                        fnAction();
                    }
                }
            });
        });
    }

    /**
     * @deprecated
     */
    First(): Zone | undefined {
        return this.m_Zones[0];
    }

    /**
     * @deprecated
     */
    ForEach(callback: (zone: GlobalZone) => void): void {
        this.m_Zones.forEach(callback);
    }

    /**
     * @deprecated
     */
    Length(): number {
        return this.m_Zones.length;
    }
}

/**
 * For events syncing with multiple zones
 */
class EventSyncObject {
    m_Events: JQuery.Deferred<void> | undefined;
    m_Completions: (() => void)[] = [];

    /**
     * @params zones - zones to register event to
     * @params event - name of event
     */
    constructor(zones: Zone[], event: string) {
        zones.forEach((zone) => {
            const deferredPromise = jQuery.Deferred();
            this.m_Events = deferredPromise;
            // TODO: have this not work with jquery?
            zone.registerEventInterrupt(event, deferredPromise);
        });

        this.m_Events?.then(() => {
            this.m_Completions.forEach((completion) => {
                completion();
            });
        });
    }

    Then(callbackFn: () => void): void {
        if (this.m_Completions.includes(callbackFn)) {
            this.m_Completions.push(callbackFn);
        }
    }
}

/**
 * Functions to assist on finding zones
 * @deprecated
 */
export const Zones = {
    /**
     * @deprecated
     */
    m_CurrentZoneId: 0,

    /**
     * @deprecated
     */
    FindByName(nameOrNames: string | string[]): ZoneCollection {
        if (!Array.isArray(nameOrNames)) {
            nameOrNames = [nameOrNames];
        }

        const flatDisplayZones: Zone[] = getDisplays()
            .map((d) => d.zones)
            .flat();
        const filteredZones: Zone[] = [];
        flatDisplayZones.forEach((zone) => {
            if (nameOrNames.includes(zone.name)) {
                filteredZones.push(zone);
            }
        });

        return new ZoneCollection(filteredZones);
    },
    /**
     * @deprecated
     */
    Current(): ZoneCollection {
        if (!Zones.m_CurrentZoneId) {
            return new ZoneCollection([]);
        }

        const currentZone = getZoneById(Zones.m_CurrentZoneId);
        return new ZoneCollection(currentZone ? [currentZone] : []);
    },
    /**
     * @deprecated
     */
    All(): ZoneCollection {
        const zones = getDisplays()
            .map((d) => d.zones)
            .flat();
        return new ZoneCollection(zones);
    },
    /**
     * @deprecated
     */
    setCurrentZoneId(currentZoneId: number): void {
        Zones.m_CurrentZoneId = currentZoneId;
    },
};
